export default {
  badge: 'Distintivo',
  open: 'Apri',
  close: 'Chiudi',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Annulla',
  },
  dataIterator: {
    noResultsText: 'Nessun risultato trovato',
    loadingText: 'Caricamento in corso...',
  },
  dataTable: {
    itemsPerPageText: 'Righe per pagina:',
    ariaLabel: {
      sortDescending: 'Ordinati in ordine decrescente.',
      sortAscending: 'Ordinati in ordine crescente.',
      sortNone: 'Non ordinato.',
      activateNone: `Attiva per rimuovere l'ordinamento.`,
      activateDescending: 'Attiva per ordinare in ordine decrescente.',
      activateAscending: 'Attiva per ordinare in ordine crescente.',
    },
    sortBy: 'Ordina per',
  },
  dataFooter: {
    itemsPerPageText: 'Elementi per pagina:',
    itemsPerPageAll: 'Tutti',
    nextPage: 'Pagina seguente',
    prevPage: 'Pagina precedente',
    firstPage: 'Prima pagina',
    lastPage: 'Ultima pagina',
    pageText: '{0}-{1} di {2}',
  },
  dateRangeInput: {
    divider: 'a',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Seleziona date',
      header: 'Inserisci date',
    },
    title: 'Seleziona data',
    header: 'Inserisci data',
    input: {
      placeholder: 'Inserisci data',
    },
  },
  noDataText: 'Nessun elemento disponibile',
  carousel: {
    prev: 'Vista precedente',
    next: 'Prossima vista',
    ariaLabel: {
      delimiter: 'Slide carosello {0} di {1}',
    },
  },
  calendar: {
    moreEvents: '{0} di più',
    today: 'Today',
  },
  input: {
    clear: 'Cancella {0}',
    prependAction: 'Azione precedente {0}',
    appendAction: 'Azione successiva {0}',
    otp: 'Inserisci il codice OTP {0}',
  },
  fileInput: {
    counter: '{0} file',
    counterSize: '{0} file ({1} in totale)',
  },
  fileUpload: {
    title: 'Drag and drop files here',
    divider: 'or',
    browse: 'Browse Files',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigazione impaginazione',
      next: 'Pagina seguente',
      previous: 'Pagina precedente',
      page: 'Vai alla pagina {0}',
      currentPage: 'Pagina corrente, pagina {0}',
      first: 'Prima pagina',
      last: 'Ultima pagina',
    },
  },
  stepper: {
    next: 'Successivo',
    prev: 'Precedente',
  },
  rating: {
    ariaLabel: {
      item: 'Valutazione {0} di {1}',
    },
  },
  loading: 'Caricamento...',
  infiniteScroll: {
    loadMore: 'Carica altro',
    empty: 'Nessun elemento',
  },
}
